import { generateTestId } from "@client-shared";

export const setCommonHeaderTestId = (identifier: string): string => generateTestId("CommonHeader", identifier);
